import script from "./GenerationComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./GenerationComponent.vue?vue&type=script&setup=true&lang=ts"

import "./GenerationComponent.vue?vue&type=style&index=0&id=d212b704&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d212b704"]])

export default __exports__